export default __webpack_public_path__ + "static/media/out.3b43aeb6.svg";